import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import Select from '../../components/Common/Select';
import Modal from "../../components/Common/Modal";
import CategoryList from './CategoryList';
import MyExchange from './Mine';
import AddressModal from "../../components/Modal/AddressModal";
import ExchangeRuleModal from '../../components/Modal/ExchangeRuleModal';
import * as actions from '../../store/action/exchange';
import exchange from '../../common/exchange';
import common from '../../common/common';
import { categoryMap } from '../../common/category';
import { Commun } from "../../utils/axios";
import eventBus from '../../utils/event-bus';
import styles from './index.module.scss';
import Cookies from 'js-cookie';
import { isAddressSdkOrg } from '../../common/addressSdk';

//展示实物兑换入口的机构 2000 && 美刻
const showExchangeList = [2000, 999, 30000]
const isMeike = window.location.host.includes('test3d') || window.location.host.includes('metcom')

class Exchange extends React.Component {
    constructor(props) {
        super(props);
        this.tabList = [
            {
                label: intl.get('AVATAR'),
                type: 'avatar'
            },
            {
                label: intl.get('SUBTITLES'),
                type: 'subtitles'
            },
            {
                label: intl.get('VIDEO'),
                type: 'video'
            },
            // {
            //     label: intl.get('GIFT'),
            //     type: 'gift'
            // },
            {
                label: intl.get('MY_EXCHANGE'),
                type: 'mine'
            }
        ];
        this.state = {
            organizationList: [], // 分校列表
            starCount: 0, // 星星数
            mainOrgId: '', // 主机构ID
            studentInfo: {},
            resolvedU2Token: '',
        }
    }

    static defaultProps = {
        pageType: 'page'
    };

    static propTypes = {
        pageType: PropTypes.string // 页面类型 page-普通页面 modal-弹窗页面
    };

    componentDidMount() {
        this.getStudentInfo();
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        let addId = params.get('address_id');
        if (addId) {
            let value = params.get('curItem');
            let pro = JSON.parse(value);
            params.delete('address_id');
            params.delete('curItem');
            url.search = params.toString();
            window.history.replaceState(null, null, url.toString());
            exchange.onAddressCompleted(pro, addId);
        }
        if (this.props.pageType === 'page') document.title = intl.get('STAR_EXCHANGE');
        this.props.changeTabType(this.tabList[0].type);

        this.getOrganizationList();

        // 订阅更新星星数事件
        eventBus.addEventListener('updateStarCount',  this.getStarCount);
    }

    componentDidUpdate(prevProps, prevState) {
        const { organization } = this.props;
        // 机构改变后，获取该机构下的星星数
        if (organization && organization !== prevProps.organization) {
            this.getStarCount();
        }
    }

    componentWillUnmount() {
        this.props.resetData(); // 重置数据
        eventBus.removeEventListener('updateStarCount', this.getStarCount);
    }

    // 获取分校列表
    getOrganizationList = () => {
        Commun.get(`${common.starApiPrefix}/user/org-list`).then(res => {
            const organizationList = res || [];

            // 按照星星数排序
            organizationList.sort((a, b) => {
                return b.starNum - a.starNum
            });

            this.setState({
                organizationList
            });

            organizationList[0] && this.props.changeOrganization(organizationList[0].organizationId);
        }).catch(error => {
            console.log(error);
        });
    };

    // 查询机构下的星星数
    getStarCount = (organization = this.props.organization) => {
        Commun.get(`${common.starApiPrefix}/user/balance`, {
            organizationId: organization
        }).then(res => {
            this.setState({
                starCount: res.balance
            })
        });
    };

    // 修改当前选中tab
    changeTabType = (type) => {
        this.props.changeTabType(type);
    };

    // 选择的学校改变后的回调
    onSchoolChange = (value) => {
        this.props.changeOrganization(value);
        console.log("机构切换：", value);
    };

    // 地址保存成功后的回调
    onAddressSaveSuccess = async () => {
        console.log('地址保存成功后的回调/pages/Exchange', this.props, this.props.processExchangeCurItem, Object.getOwnPropertyNames(this.props.processExchangeCurItem).length);
        eventBus.emit('closeConfirmAddressModal');  // 保存成功后，关闭确认地址信息弹窗
        this.props.changeAddressModalVisible(false);
        if (Object.getOwnPropertyNames(this.props.processExchangeCurItem).length) {
          try {
              const orderNo = await exchange.createOrder() // 生成订单号
              let res = await exchange.exchangeProduct({ ...this.props.processExchangeCurItem, orderNo }); // 兑换商品
              if (res) {
                Modal.info({
                  title: intl.get('EXCHANGE_SUCCESS'),
                  content: intl.get('MAIL_TIPS'),
                  okText: intl.get('RIGHT_TEXT')
                });
              }
          } catch(error) {
            console.error(error);
          }
          this.getStarCount();// 更新星星数
        } else {
          Modal.info({
            title: intl.get('EXCHANGE_SUCCESS'),
            content: intl.get('MAIL_TIPS'),
            okText: intl.get('RIGHT_TEXT')
          });
        }
    };

    // 地址点击取消后的回调
    onAddressCancel = () => {
        this.props.changeAddressModalVisible(false);
    };

    // 展示兑换规则页面
    showRuleModal = () => {
        this.props.changeRuleModalVisible(true);
    };

    // 隐藏兑换规则页面
    hideRuleModal = () => {
        this.props.changeRuleModalVisible(false);
    };
    // 获取StudetCode
    getStudentCode = () => {
        return Commun.get(`${common.userApiPrefix}/u2/token`);
    }
    getStudentInfo = async() => {
        let res = await Commun.get(`${common.userApiPrefix}/simple-info`);
        if (isAddressSdkOrg(res.mainOrgId)) {
            Commun.get(`${common.userApiPrefix}/u2/token`).then(studentInfo => {
                const { u2Token, mainOrgId } = studentInfo;
                const urlU2Token = common.getSearchParam()?.accessToken || '';
                const resolvedU2Token = u2Token || urlU2Token;
                studentInfo.roleId = res.roleId || 0
                Cookies.set('U2AT', resolvedU2Token, { domain: '.xdf.cn' });
                this.setState({
                    mainOrgId,
                    studentInfo,
                    resolvedU2Token,
                });
            }).catch(err => {
                console.log('getStudentInfo', err);
            })
        }
    }

    getUserInfo = () => {
        Commun.get(`${common.userApiPrefix}/address`).then(res => {
            const { consignee = '', phone = '', address = '' } = res[res.length - 1] || {};
            this.setState({
                name: consignee,
                phone,
                address
            })
        }).catch(error => {
            console.log(error);
        });
    };


    render() {
        const { pageType, tabType, organization, addressModalVisible, ruleModalVisible } = this.props;
        const { organizationList, starCount, mainOrgId, studentInfo, resolvedU2Token } = this.state;
        // 只有机构2000展示实物兑换
        let giftItem  = { label: intl.get('GIFT'), type: 'gift'};
        let newTabList = ((showExchangeList.includes(mainOrgId) || isMeike)) ? [...this.tabList.slice(0, this.tabList.length - 1), giftItem, ...this.tabList.slice(this.tabList.length - 1)] : this.tabList;
        let content;
        switch(tabType) {
            case 'avatar':
            case 'subtitles':
            case 'video':
            case 'gift':
                content = <CategoryList category={categoryMap[tabType]} studentInfo={studentInfo} resolvedU2Token={resolvedU2Token} />;
                break;
            case 'mine':
                content = <MyExchange/>;
                break;
        }
        return (
            <React.Fragment>
                <div
                    className={styles.layoutContainer}
                    style={{
                        background: pageType === 'modal' ? 'transparent' : '#082734'
                    }}
                >
                    <div className={styles.layoutHeader}>
                        <div className={styles.starInfo}>
                            <div className={styles.starNum}>
                                <p className={styles.totalCount}>{intl.get('TOTAL')}<span className={styles.count}>{starCount}</span></p>
                                <span className={`icon-star ${styles.iconStar}`}/>
                            </div>
                            {
                                common.isMobile() && <div className={styles.rule} onClick={this.showRuleModal}>{intl.get('STAR_EXCHANGE_RULE')} <i className={`${styles.iconQuestion} icon-question-circle`}/></div>
                            }
                        </div>
                        <div className={styles.schoolSelect}>
                            <label>{intl.get('CURRENT_SCHOOL')}</label>
                            <div className={styles.selectBox}>
                                <Select
                                    options={organizationList}
                                    optionValueKey="organizationId"
                                    optionLabelKey="organizationName"
                                    displayValueKey="organizationName"
                                    value={organization}
                                    onChange={this.onSchoolChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.layoutContent}>
                        <ul className={`${styles.menuList} light-scroll-bar`}>
                            {
                                newTabList.map(item =>
                                    <li className={item.type === tabType ? styles.active : ''} key={item.type} onClick={() => {this.changeTabType(item.type)}}>
                                        {item.label}
                                    </li>
                                )
                            }
                        </ul>
                        <div className={`${styles.mainContent} light-scroll-bar`}>
                            {
                                content
                            }
                        </div>
                    </div>
                </div>
                {/*PC端 收货地址弹层 start*/}
                {
                    !common.isMobile() && addressModalVisible &&
                    <AddressModal
                        visible={addressModalVisible}
                        onSuccess={this.onAddressSaveSuccess}
                        onCancel={this.onAddressCancel}
                    />
                }
                {/*PC端 收货地址弹层 end*/}
                {/*兑换规则弹窗 start*/}
                <ExchangeRuleModal
                    visible={ruleModalVisible}
                    organization={organization}
                    onCancel={this.hideRuleModal}
                />
                {/*兑换规则弹窗 end*/}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    ...state.exchange
});

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Exchange);